import { Modal, useModals } from 'almanac-ui/Modal'
import { InviteToWorkspace } from 'components/ShareSheet/InviteToWorkspace'
import { EmailValue } from 'components/ShareSheet/RecipientSelector/Types'
import { useState } from 'react'

interface Props {
  onSubmit: ({ addMembers }: { addMembers: boolean }) => Promise<void>
  newRecipients: EmailValue[]
}

export const InviteMoreReviewersModal = ({ onSubmit, newRecipients }: Props) => {
  const [inviteToWorkspace, setInviteToWorkspace] = useState<boolean>(false)
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
  const { closeModal } = useModals()

  return (
    <Modal.Root>
      <InviteToWorkspace
        inviteToWorkspace={inviteToWorkspace}
        setInviteToWorkspace={setInviteToWorkspace}
        goBack={closeModal}
        onSubmit={async () => {
          setIsSubmitting(true)
          await onSubmit({ addMembers: inviteToWorkspace })
          setIsSubmitting(false)
          closeModal()
        }}
        isSubmitting={isSubmitting}
        newRecipients={newRecipients}
      />
    </Modal.Root>
  )
}
